module.exports = __webpack_public_path__ + "img/KI.fc0d6909.svg";